import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Read English, pick the Vietnamese translation. */
export function EnglishToVietnamese({ word, distractors, onAnswer }: ChallengeProps) {
  const choices = useChoices(word, distractors);
  const { picked, handle, teachOverlay } = usePickHandler(word, onAnswer);

  return (
    <>
      <ChallengeShell
        tag="Translate"
        prompt={`What does "${word.english}" mean?`}
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.vietnamese}</span>}
        />
      </ChallengeShell>
      {teachOverlay}
    </>
  );
}
